import React, { useEffect, useState } from 'react'
import { Button, Grid, Typography, withStyles } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import Filter from './Filter'
import List from './List'
import { fetchGerencyReport, makeRelatory } from '../GerencyReportsActions'
import styles from '../../../../../resources/theme/global'
import NoteAddIcon from '@material-ui/icons/NoteAdd'

const GerencyReport = props => {
  const dispatch = useDispatch()

  const [form, setForm] = useState({
    per_page: 10,
    page: 1,
    attendant_id: '',
    date_start: '',
    date_end: '',
  })

  const { classes } = props

  useEffect(() => {
    dispatch(fetchGerencyReport(form))
  }, [form])

  const handleExport = () => {
    dispatch(makeRelatory(form))
  }

  return (
    <>
      <Grid
        container
        className={classes.pageHead}
        spacing={1}
        alignItems="center"
      >
        <Grid item xs>
          <Typography variant="h4" color="secondary">
            Relatório Gerencial
          </Typography>
        </Grid>
        <Grid item>
          <Button color="primary" variant="contained" onClick={handleExport}>
            <NoteAddIcon className={classes.btnIcon} /> Relatório
          </Button>
        </Grid>
        <Grid item>
          <Filter classes={classes} form={form} setForm={setForm} />
        </Grid>
        <Grid item xs={12}>
          <List classes={classes} setForm={setForm} form={form} />
        </Grid>
      </Grid>
    </>
  )
}

export default withStyles(styles)(GerencyReport)
